import Cookies from 'js-cookie';
import { unauth } from '../../shared/utils/globalConfig';
import { useSelector} from 'react-redux';

export const formatDate = (date) => {
  const value = new Date(date);
  let dd = value.getDate();
  let mm = value.getMonth() + 1;
  const yyyy = value.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return mm + '/' + dd + '/' + yyyy;
};

export const formatDateString = (date) =>{
  
  const inputDate = date
    const [month, day, year] = inputDate?.split('/');

    // Convert the two-digit year to a four-digit year
    const fullYear = parseInt(year) < 50 ? parseInt(year) + 2000 : parseInt(year) ;

    const dateObject = new Date(fullYear, month - 1, day);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    const fullDateString = dateObject.toLocaleDateString('en-US', options);
    return fullDateString
}

export const getDestList = (destinations, key) => {
  let destList = destinations && destinations.map((des) => {
    return des[key];
  })

  return destList;
}
export const getDestListName = (destinations, name) => {
  let destList = destinations && destinations.map((des) => {
    return des[name];
  })
  return destList;
}

export const addSpace = (string, key) => {
  return string && string?.split(key).join(key + ' ')
}

export const replaceText = (string, pattern, replace) => {
  return string.replace(pattern, replace)
}

export const addHeaders = (headers, unauth = false) => {

  headers.set('flowName', unauth ? "UnAuth-INTL-NSA" :"Auth-INTL-NSA");
  return headers;
}

export const getErrorMessage = (response) => {
  const items = response?.data?.body?.sections[0]?.contents && response?.data?.body?.sections[0]?.contents[0]?.items;
  const title = items && items.find(c => c.itemKey === "headerText");
  const message = items && items.find(c => c.itemKey === "subHeaderText");
  return { title, message };
}

export const getDevicesPayload = (selectedDates, selectedDestinations) => {
  const {deviceAndPlansPayload} = useSelector(state => state?.persistantReducer);
 
  return deviceAndPlansPayload;
}

export const getPaygoInfoList = (destinations, key) => {
  if(unauth){
  let isCanMex = destinations?.filter(destination =>
      destination?.key === "CAN" || destination?.key === "MEX"
  );
  let isPayGoIncluded;
  if (isCanMex?.length > 0) {
      isPayGoIncluded = destinations?.filter(destination =>
          destination?.paygoOnly === "Y"
      );
  }
  if ((isCanMex?.length + isPayGoIncluded?.length) == destinations?.length && isPayGoIncluded?.length > 0) {
      return "Y";
  } else {
      return "N";
  }
  }
};


